import type { ComputedRef, Ref } from 'vue';
import { computed } from 'vue';

import type { FormSchema } from '@modules/forms/components/VForm/types';
import { EFormInputTypes } from '@modules/forms/enums';

export interface ITrackerDeal {
  id: number;
  title: string;
}

export interface ITrackerDealForm {
  condition_id: number;
  date: Date;
  serial_id?: number;
  merchant_name?: string;
}

export interface ITrackerDealFormComposableOptions {
  conditions: ITrackerDeal[];
  conditionLabel?: string;
  conditionValue?: number;
  dateLabel?: string;
  dateValue?: Date;
  isLoading?: boolean;
  minDate?: Date;
}

export type ITrackerDealFormSchema = FormSchema<ITrackerDealForm, never, {
  condition_id: {
    selectOptionLabel: 'title';
    selectOptionValue: 'id';
  };
}>;

export interface ITrackerDealFormComposable {
  formSchema: ComputedRef<ITrackerDealFormSchema>;
}

export default function useTrackerDealForm(options: Ref<ITrackerDealFormComposableOptions>): ITrackerDealFormComposable {
  const formSchema = computed<ITrackerDealFormSchema>(() => ({
    condition_id: {
      type: EFormInputTypes.SELECT,
      label: options.value.conditionLabel,
      options: options.value.conditions,
      value: options.value.conditionValue,
      loading: options.value.isLoading,
      optionLabel: 'title',
      optionValue: 'id',
      required: true,
    },
    date: {
      type: EFormInputTypes.DATE,
      label: options.value.dateLabel,
      value: options.value.dateValue,
      required: true,
      view: 'month',
      dateFormat: 'mm.yy',
      minDate: options.value.minDate,
    },
  }));

  return {
    formSchema,
  };
}
